export default [{
  path: 'd-fin/gefin-relatorios/vendas-produtos',
  name: 'vendas-produtos',
  component: () => import('./index'),
  meta: {
    visible: true,
    title: 'Produtos',
    order: '6',
    breadcrumb: [
      { name: 'Home', link: 'home' },
      { name: 'D-FIN', link: 'd-fin' },
      { name: 'Relatorios', link: 'gefin-relatorios' },
      { name: 'Produtos' }
    ]
  }
}]
